import { Box, Divider, Paper, Skeleton, Stack, Tab, Tabs } from '@mui/material';
import { TAB_STYLES } from '../JiraSettingsFlow';

const TabContent = () => {
  return (
    <Stack direction={'column'} gap={1} sx={{ alignItems: 'center' }}>
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="rectangular" width={210} height={20} />
    </Stack>
  );
};

export const JiraSettingsFlowSkeleton = () => {
  return (
    <Paper sx={{ flexGrow: 1, display: 'flex' }}>
      <Tabs orientation="vertical" value={1} variant="scrollable" sx={TAB_STYLES}>
        <Tab label={<TabContent />}></Tab>
        <Tab label={<TabContent />}></Tab>
        <Tab label={<TabContent />}></Tab>
      </Tabs>
      <Box sx={{ width: '100%', padding: 3 }}>
        <Stack sx={{ height: '100%', justifyContent: 'space-between' }}>
          <Box sx={{ height: '80%' }}>
            <Skeleton variant="rectangular" width={210} height={20} />
          </Box>
          <Box>
            <Divider textAlign="center" />
            <Stack direction={'row'} sx={{ pt: 1, justifyContent: 'space-between' }}>
              <Skeleton variant="rectangular" width={100} height={20} />
              <Skeleton variant="rectangular" width={100} height={20} />
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Paper>
  );
};
